// // import React from 'react';
// // import productDummImg from 'src/assets/images/product-dummy-img.png';
// // import leftIcon from 'src/assets/images/product-slider-left-icon.png';
// // import rightIcon from 'src/assets/images/product-slider-right-icon.png';
// // import Slider from 'react-slick';

// // const ProductDetailSlider: React.FC<{ galleryImages: string[] }> = ({ galleryImages = [] }) => {
// //     const settings = {
// //         dots: false,
// //         infinite: true,
// //         speed: 500,
// //         slidesToShow: 3,
// //         slidesToScroll: 1,
// //         autoplay: true,
// //         autoplaySpeed: 3000,
// //         draggable: false,
// //         swipe: false,
// //         responsive: [
// //             {
// //                 breakpoint: 1024,
// //                 settings: {
// //                     slidesToShow: 2,
// //                 },
// //             },
// //         ],
// //         // Custom arrows
// //         prevArrow: <div><img src={leftIcon} alt='' /></div>,
// //         nextArrow: <div><img src={rightIcon} alt='' /></div>,
// //     };

// //     return (
// //         <div className='product-detail-slider-main'>
// //             {galleryImages?.length > 3 ?
// //                 <Slider {...settings}>
// //                     {galleryImages?.map((item, index) => (
// //                         <div key={index} className='product-detail-slider'>
// //                             <img alt='gallery' src={`${item}`} />
// //                         </div>
// //                     ))}
// //                 </Slider>
// //                 :
// //                 <div className="product-detail-slider-issue">
// //                     {galleryImages?.map((item, index) => (
// //                         <div key={index} className='product-detail-slider'>
// //                             <img alt='gallery' src={`${item}`} />
// //                         </div>
// //                     ))}
// //                 </div>
// //             }
// //         </div>
// //     );
// // };

// // export default ProductDetailSlider;
// import React, { useState } from "react";
// import productDummImg from "src/assets/images/product-dummy-img.png";
// import leftIcon from "src/assets/images/product-slider-left-icon.png";
// import rightIcon from "src/assets/images/product-slider-right-icon.png";
// import Slider from "react-slick";
// import { ImageBaseUrl } from "src/lib/constans";
// import FavoriteCoponent from "../GlobalComponents/FavoriteCoponent";
// import ShareComponent from "../GlobalComponents/ShareComponent";
// import { getElementProperty } from "src/helpers/helperFunctions";

// interface ProductDetailSliderProps {
//   galleryImages: any;
//   onThumbnailClick: (imageSrc: string) => void;
//   productId?: string;
//   isLiked?: boolean;
//   onLikeProduct?: (id: string, status: boolean) => void;
// }

// const ProductDetailSlider: React.FC<ProductDetailSliderProps> = ({
//   galleryImages = [],
//   onThumbnailClick,
//   productId,
//   isLiked = false,
//   onLikeProduct = () => {},
// }) => {
//   const [activeImageIndex, setActiveImageIndex] = useState(0);

//   console.log(galleryImages, "aaaaaaaaaa");
//   const settings = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     autoplay: false,
//     // autoplaySpeed: 3000,
//     draggable: true,
//     swipe: true,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 2,
//         },
//       },
//     ],
//     // Custom arrows
//     prevArrow: <div>{/* <img src={leftIcon} alt="Previous" /> */}</div>,
//     nextArrow: <div>{/* <img src={rightIcon} alt="Next" /> */}</div>,
//   };

//   return (
//     <div>
//       <div className="w-full box-design relative pb-3 max-h-[50vh] h-full flex items-center justify-center">
//         <Slider {...settings}>
//           {galleryImages?.map((item: any, index: any) => (
//             <div
//               onClick={() => onThumbnailClick(`${item}`)}
//               key={index}
//               className="product-detail-slider"
//             >
//               <img
//                 alt="Gallery Thumbnail"
//                 src={`${item}`}
//                 className="slider-thumbnail"
//               />
//             </div>
//           ))}
//         </Slider>
//       </div>
//       <div className="w-full" id="galary-image-container">
//         <div className="flex">
//           {galleryImages?.map((item: any, index: any) => (
//             <div
//               onClick={() => onThumbnailClick(`${item}`)}
//               key={index}
//               className=""
//               style={{
//                 width: getElementProperty("#galary-image-container")
//                   ? getElementProperty("#galary-image-container")
//                       ?.clientWidth || 600 / 4
//                   : 150,
//                 height: getElementProperty("#galary-image-container")
//                   ? getElementProperty("#galary-image-container")
//                       ?.clientWidth || 600 / 4
//                   : 150,
//               }}
//             >
//               <img
//                 alt="Gallery Thumbnail"
//                 src={`${item}`}
//                 className="slider-thumbnail"
//               />
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProductDetailSlider;

// import React from 'react';
// import productDummImg from 'src/assets/images/product-dummy-img.png';
// import leftIcon from 'src/assets/images/product-slider-left-icon.png';
// import rightIcon from 'src/assets/images/product-slider-right-icon.png';
// import Slider from 'react-slick';

// const ProductDetailSlider: React.FC<{ galleryImages: string[] }> = ({ galleryImages = [] }) => {
//     const settings = {
//         dots: false,
//         infinite: true,
//         speed: 500,
//         slidesToShow: 3,
//         slidesToScroll: 1,
//         autoplay: true,
//         autoplaySpeed: 3000,
//         draggable: false,
//         swipe: false,
//         responsive: [
//             {
//                 breakpoint: 1024,
//                 settings: {
//                     slidesToShow: 2,
//                 },
//             },
//         ],
//         // Custom arrows
//         prevArrow: <div><img src={leftIcon} alt='' /></div>,
//         nextArrow: <div><img src={rightIcon} alt='' /></div>,
//     };

//     return (
//         <div className='product-detail-slider-main'>
//             {galleryImages?.length > 3 ?
//                 <Slider {...settings}>
//                     {galleryImages?.map((item, index) => (
//                         <div key={index} className='product-detail-slider'>
//                             <img alt='gallery' src={`${item}`} />
//                         </div>
//                     ))}
//                 </Slider>
//                 :
//                 <div className="product-detail-slider-issue">
//                     {galleryImages?.map((item, index) => (
//                         <div key={index} className='product-detail-slider'>
//                             <img alt='gallery' src={`${item}`} />
//                         </div>
//                     ))}
//                 </div>
//             }
//         </div>
//     );
// };

// export default ProductDetailSlider;
import React, { useCallback, useEffect, useState } from "react";
import productDummImg from "src/assets/images/product-dummy-img.png";
import leftIcon from "src/assets/images/product-slider-left-icon.png";
import rightIcon from "src/assets/images/product-slider-right-icon.png";
import { ImageBaseUrl } from "src/lib/constans";
import FavoriteCoponent from "../GlobalComponents/FavoriteCoponent";
import ShareComponent from "../GlobalComponents/ShareComponent";
import { getElementProperty } from "src/helpers/helperFunctions";
import useEmblaCarousel from "embla-carousel-react";
import "src/assets/css/Carousel/DetailsCarousels.css";
import HowManytDealOFF from "../GlobalComponents/HowManytDealOFF";
import Skeleton from "@mui/material/Skeleton";

interface ProductDetailSliderProps {
  galleryImages: any[];
  onThumbnailClick: (imageSrc: string) => void;
  productId?: string;
  isLiked?: boolean;
  onLikeProduct?: (id: string, status: boolean) => void;
  shareButton?: boolean;
  shareOptions?: {
    title?: string;
    text?: string;
  };
  addiltionContent?: React.ReactNode;
  salePrice?: number;
  regularPrice?: number;
  loading?: boolean;
}

const ProductDetailSlider: React.FC<ProductDetailSliderProps> = ({
  galleryImages = [],
  onThumbnailClick,
  productId,
  isLiked = false,
  onLikeProduct = () => {},
  shareButton = true,
  shareOptions = {},
  addiltionContent,
  salePrice,
  regularPrice,
  loading = false,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  // const [carouselImagesHeight, setCarouselImagesHeight] = useState(
  //   (window?.innerHeight / 100) * 55
  // );
  const [emblaMainRef, emblaMainApi] = useEmblaCarousel();
  const [emblaThumbsRef, emblaThumbsApi] = useEmblaCarousel({
    containScroll: "keepSnaps",
    dragFree: true,
    slidesToScroll: 1,
    // slidesToShow: 4,
  });

  const onThumbClick = useCallback(
    (index: number) => {
      if (!emblaMainApi || !emblaThumbsApi) return;
      emblaMainApi.scrollTo(index);
    },
    [emblaMainApi, emblaThumbsApi]
  );

  const onSelect = useCallback(() => {
    if (!emblaMainApi || !emblaThumbsApi) return;
    setSelectedIndex(emblaMainApi.selectedScrollSnap());
    emblaThumbsApi.scrollTo(emblaMainApi.selectedScrollSnap());
  }, [emblaMainApi, emblaThumbsApi, setSelectedIndex]);

  useEffect(() => {
    if (!emblaMainApi) return;
    onSelect();

    emblaMainApi.on("select", onSelect).on("reInit", onSelect);
  }, [emblaMainApi, onSelect]);

  return (
    <div className="embla">
      <div
        className="embla__viewport relative border border-[#E6E6E6] shadow-[0px_0px_3px_#00000029] rounded-xl"
        ref={emblaMainRef}
        id="carousel-container"
      >
        <div className="embla__container">
          {loading ? (
            <div className="w-full h-full flex items-center justify-center aspect-[1/0.9]">
              <Skeleton variant="rectangular" width="100%" height="100%" className="w-full max-h-[100%]" />
            </div>
          ) : (
            galleryImages.map((images, index) => (
            <div
              className="embla__slide flex items-center justify-center"
              key={index}
            >
              <img
                src={images ? `${ImageBaseUrl}${images}` : productDummImg}
                alt={`Slide ${index + 1}`}
                className="w-full h-auto max-h-[100%] object-contain"
              />
            </div>
          )))}
        </div>
        {addiltionContent && !loading && addiltionContent}
        {salePrice && regularPrice && !loading ? (
          <HowManytDealOFF
            salePrice={salePrice}
            regularPrice={regularPrice}
            detailsUI
          />
        ) : null}
        { !loading ? <div className="absolute top-3 right-3 flex items-center gap-2 flex-col">
          <FavoriteCoponent
            id={productId || "dummy"}
            liked={isLiked}
            onLikeProduct={onLikeProduct}
            category="pharmacy"
          />
          {shareButton && (
            <ShareComponent
              shareText={shareOptions?.text}
              shareTitle={shareOptions?.title}
              id="share-btn"
            />
          )}
        </div> : null}
      </div>

      <div className="embla-thumbs">
        <div className="embla-thumbs__viewport" ref={emblaThumbsRef}>
          <div className="embla-thumbs__container">
            {loading ? Array.from({length: 4}).map((item, index) => (
              <div className="embla-thumbs__slide" key={index}>
                <Skeleton variant="rectangular" width="100%" height="100%" className="w-[92%] rounded-sm aspect-[1/1]" />
              </div>
            )) : galleryImages.map((image, index) => (
              <div
                className={`embla-thumbs__slide ${
                  index === selectedIndex ? "embla-thumbs__slide--selected" : ""
                }`}
                key={index}
                onClick={() => onThumbClick(index)}
              >
                <div className="w-full h-full flex items-center justify-center rounded-lg border border-[#E6E6E6] shadow-[0px_0px_3px_#00000029] overflow-hidden bg-white">
                  <img
                    src={image ? `${ImageBaseUrl}${image}` : productDummImg}
                    alt={`Thumbnail ${index + 1}`}
                    className="w-[90%] h-auto max-h-[90%] object-contain"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailSlider;
